import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, FlexContainer, Rectangle, Typography } from '@pitchero/react-ui';
import { DateTime } from 'luxon';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import flattenDayEntries from '../matches/flatten-entries';
import MatchDetails from '../matches/match-details';
import TrainingSession from '../matches/training-session';
import ClubEvent from './calendar-club-event';

const CalendarSummary = ({ club, data, selectedDate }) => {
  if (!data) return null;
  const day = data.find((item) => item.date === selectedDate.toFormat('yyyy-MM-dd'));
  const events = flattenDayEntries(day);

  let nextDay = null;
  if (events.length === 0) {
    // Look for next day with events
    const dayIndex = data.findIndex((item) => item.date === selectedDate.toFormat('yyyy-MM-dd'));
    const searchArray = data.slice(dayIndex);
    nextDay = searchArray.find((item) => flattenDayEntries(item).length > 0) || null;
  }

  const renderEvent = (event) => {
    if (event.sortType === 'fixture') {
      return (
        <Rectangle
          key={`${event.id}-${event.teamId}`}
          radius="8px"
          style={{ overflow: 'hidden' }}
          component="div"
        >
          <MatchDetails
            match={event}
            club={club}
            type={event.hasOutcome ? 'result' : 'fixture'}
            isMobile
          />
        </Rectangle>
      );
    }

    if (event.sortType === 'training') {
      return (
        <Rectangle key={event.id} radius="8px" style={{ overflow: 'hidden' }} component="div">
          <TrainingSession club={club} session={event} isLast />
        </Rectangle>
      );
    }

    if (event.sortType === 'event') {
      return (
        <Rectangle key={event.id} radius="8px" style={{ overflow: 'hidden' }} component="div">
          <ClubEvent club={club} event={event} />
        </Rectangle>
      );
    }

    return null;
  };

  return (
    <Cushion horizontal="small" component="div" style={{ width: '100%', boxSizing: 'border-box' }}>
      <Rectangle fill="#f5f5f5" radius="8px" style={{ padding: '10px' }} component="div">
        <FlexContainer flexDirection="column" style={{ gap: '10px' }}>
          <Typography size={16} weight="bold" color="#000">
            {selectedDate.toFormat('dd MMM')}
          </Typography>
          {events.length > 0 ? (
            events.map(renderEvent)
          ) : (
            <>
              <Rectangle fill="#fff" radius="8px" style={{ padding: '10px' }}>
                <Typography size={14} color="#000">
                  No events today
                </Typography>
              </Rectangle>
              {nextDay && (
                <>
                  <Typography size={16} weight="bold" color="#000">
                    {`Next Up - ${DateTime.fromFormat(nextDay.date, 'yyyy-MM-dd').toFormat(
                      'dd MMM',
                    )}`}
                  </Typography>
                  {flattenDayEntries(nextDay).map(renderEvent)}
                </>
              )}
            </>
          )}
        </FlexContainer>
      </Rectangle>
    </Cushion>
  );
};

CalendarSummary.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedDate: PropTypes.shape().isRequired,
};

export default CalendarSummary;
